import { z } from 'zod';

export const WordSchema = z.object({
  appearance: z.array(z.string()),
  pronunciations: z.array(z.string()),
  continuations: z.array(z.string()),
  parts: z.array(z.string()),
});

export type Word = z.infer<typeof WordSchema>;
export interface KeyedWord extends Word {
  key: string;
}
